import { SHOW, HIDE } from './action-types';

type ShowToastPayloadType = {
  text: string;
};

export const showToast = (payload: ShowToastPayloadType) => ({ type: SHOW, payload });

export const hideToast = () => ({ type: HIDE });
